module.exports = {
      id: "ic-awesome-oscillator-usage",
      viewBox: "0 0 25 24",
      url: __webpack_public_path__ + "sprite-ad374a.smartcharts.svg#ic-awesome-oscillator-usage",
      toString: function () {
        return this.url;
      }
    }